<ng-container *ngIf="mode === 1">
  <ion-header class="ion-no-border" [translucent]="true">
    <ion-toolbar>
      <ion-buttons slot="start" class="navbar-back">
        <ion-button (click)="closeModal()">
          <ion-icon name="chevron-back-outline"></ion-icon> Zurück
        </ion-button>
      </ion-buttons>
      <ion-title class="ion-text-center navbar-title">Kontakt wählen</ion-title>
      <ion-buttons slot="end" class="navbar-back">
        <ion-button (click)="newContact()">
          <ion-icon name="add-outline"></ion-icon> Neu
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content fullscreen="true">
    <ng-container *ngIf="showSearch">
      <ion-searchbar [(ngModel)]="searchTerm" (ionInput)="onSearchChange($event)"></ion-searchbar>
    </ng-container>

    <div class="contact-list">
      <div class="contact-row"
           *ngFor="let item of dataListFiltered; trackBy: trackByContactId"
           [class.other-owner]="isFromAnotherOwner(item)"
           (click)="selectContact(item)">
        <div class="contact-info">
          <span class="contact-name">{{ item?.companyName || (item?.contactPerson?.firstName + ' ' + item?.contactPerson?.lastName) }}</span>
          <span class="contact-meta" *ngIf="item?.address?.street">{{ item.address.street }}{{ item.address.supplement ? ' ' + item.address.supplement : '' }}</span>
          <span class="contact-meta" *ngIf="item?.address?.zip || item?.address?.city">{{ item.address.zip }} {{ item.address.city }}</span>
          <span class="contact-meta" *ngIf="item?.email">{{ item.email }}</span>
        </div>
        <ion-icon name="chevron-forward-outline" class="contact-chevron"></ion-icon>
      </div>

      <div class="contact-empty" *ngIf="dataListFiltered?.length === 0">
        <ion-icon name="people-outline"></ion-icon>
        <span>Keine Ergebnisse</span>
        <button class="empty-new-btn" (click)="newContact()">
          <ion-icon name="add-outline"></ion-icon> Neuer Kontakt
        </button>
      </div>
    </div>
  </ion-content>
</ng-container>

<ng-container *ngIf="mode !== 1">
  <ng-container *ngIf="showSearch">
    <ion-searchbar [(ngModel)]="searchTerm" (ionInput)="onSearchChange($event)"></ion-searchbar>
  </ng-container>

  <div class="contact-list">
    <div class="contact-row"
         *ngFor="let item of dataListFiltered; trackBy: trackByContactId"
         [class.other-owner]="isFromAnotherOwner(item)">
      <div class="contact-info">
        <span class="contact-name">{{ item?.companyName || (item?.contactPerson?.firstName + ' ' + item?.contactPerson?.lastName) }}</span>
        <span class="contact-tag owner-tag" *ngIf="isAdmin() && item.owner">{{ item.owner.username }}</span>
        <span class="contact-meta" *ngIf="item?.address?.street">{{ item.address.street }}{{ item.address.supplement ? ' ' + item.address.supplement : '' }}</span>
        <span class="contact-meta" *ngIf="item?.address?.zip || item?.address?.city">{{ item.address.zip }} {{ item.address.city }}</span>
        <span class="contact-meta" *ngIf="item?.email">{{ item.email }}</span>
      </div>
      <button class="contact-action-btn" (click)="sendBackData(item)" *ngIf="mode === 0">
        <ion-icon name="create-outline"></ion-icon>
      </button>
    </div>

    <div class="contact-empty" *ngIf="dataListFiltered?.length === 0">
      <ion-icon name="people-outline"></ion-icon>
      <span>Keine Ergebnisse</span>
    </div>
  </div>
</ng-container>
